module.exports = __webpack_public_path__ + "static/img/icon_arrow_right_24.3df3593.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/educal/icon_arrow_right_24.svg
// module id = U1uY
// module chunks = 10